// Touch switch — reused across forms + settings. The button is a full 48×48
// (--tap) hit area; the visual pill (28px) is centred inside it, so the control
// meets the mobile touch floor without looking oversized. Pill geometry mirrors
// clubmanager's Switch: border-box envelope with border + padding INSIDE it and
// a thumb sized to the interior (auto-centred, can't overflow). Explicit px —
// this project's spacing scale is remapped to a coarse desktop-density ladder.
// Interior 40×20 → thumb 20px; travel = 40 − 20 = 20px.
export function Toggle({
  on,
  onToggle,
  label,
}: {
  on: boolean
  onToggle: () => void
  /** Accessible name — REQUIRED when the toggle isn't wrapped in a <label>. */
  label?: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      onClick={onToggle}
      className="grid h-[var(--tap)] w-[var(--tap)] shrink-0 place-items-center rounded-full focus-visible:outline-none focus-visible:[&>span]:shadow-[var(--ring)]"
    >
      <span
        className={`relative box-border h-[28px] w-[48px] rounded-full border-2 p-[2px] transition-colors ${
          on
            ? 'bg-[var(--accent)] border-[var(--accent)]'
            : 'bg-[var(--panel-2)] border-[var(--line-strong)]'
        }`}
      >
        <span
          className={`block h-[20px] w-[20px] rounded-full transition-transform duration-150 ${
            on ? 'translate-x-[20px] bg-[var(--accent-fg)]' : 'translate-x-0 bg-[var(--fg-muted)]'
          }`}
        />
      </span>
    </button>
  )
}
